export const chatbotStaticAssets = {
  'static/generic': 'private/chatbot/static/generic.png',

  // Ball
  'static/ball/dead': 'private/chatbot/static/ball/scared.jpg', // missing dead
  'static/ball/dirty': 'private/chatbot/static/ball/dirty.jpg',
  'static/ball/dying': 'private/chatbot/static/ball/scared.jpg', // missing dying
  'static/ball/evolve': 'private/chatbot/static/ball/ready_to_evolve.jpg',
  'static/ball/evolving': 'private/chatbot/static/ball/ready_to_evolve.jpg',
  'static/ball/hungry': 'private/chatbot/static/ball/hungry.jpg',
  'static/ball/lonely': 'private/chatbot/static/ball/lonely.jpg',
  'static/ball/very_lonely': 'private/chatbot/static/ball/very_lonely.jpg',
  'static/ball/pee': 'private/chatbot/static/ball/urge_to_urinate.jpg',
  'static/ball/very_pee':
    'private/chatbot/static/ball/strong_urge_to_urinate.jpg',
  'static/ball/scared': 'private/chatbot/static/ball/scared.jpg',
  'static/ball/sick': 'private/chatbot/static/ball/sick.jpg',
  'static/ball/tooth_decay': 'private/chatbot/static/ball/tooth_decay.jpg',
  'static/ball/very_dirty': 'private/chatbot/static/ball/very_dirty.jpg',
  'static/ball/very_hungry': 'private/chatbot/static/ball/very_hungry.jpg',
  'static/ball/fullenergy': 'private/chatbot/static/ball/fullenergy.jpg',

  // Cat
  'static/cat/dead': 'private/chatbot/static/cat/scared.jpg', // missing dead
  'static/cat/dirty': 'private/chatbot/static/cat/dirty.jpg',
  'static/cat/dying': 'private/chatbot/static/cat/scared.jpg', // missing dying
  'static/cat/evolve': 'private/chatbot/static/cat/ready_to_evolve.jpg',
  'static/cat/evolving': 'private/chatbot/static/cat/ready_to_evolve.jpg',
  'static/cat/hungry': 'private/chatbot/static/cat/hungry.jpg',
  'static/cat/lonely': 'private/chatbot/static/cat/lonely.jpg',
  'static/cat/very_lonely': 'private/chatbot/static/cat/very_lonely.jpg',
  'static/cat/pee': 'private/chatbot/static/cat/urge_to_urinate.jpg',
  'static/cat/very_pee':
    'private/chatbot/static/cat/strong_urge_to_urinate.jpg',
  'static/cat/scared': 'private/chatbot/static/cat/scared.jpg',
  'static/cat/sick': 'private/chatbot/static/cat/sick.jpg',
  'static/cat/tooth_decay': 'private/chatbot/static/cat/tooth_decay.jpg',
  'static/cat/very_dirty': 'private/chatbot/static/cat/very_dirty.jpg',
  'static/cat/very_hungry': 'private/chatbot/static/cat/very_hungry.jpg',
  'static/cat/fullenergy': 'private/chatbot/static/cat/fullenergy.jpg',

  // Crab
  'static/crab/dead': 'private/chatbot/static/crab/scared.jpg', // missing dead
  'static/crab/dirty': 'private/chatbot/static/crab/dirty.jpg',
  'static/crab/dying': 'private/chatbot/static/crab/scared.jpg', // missing dying
  'static/crab/evolve': 'private/chatbot/static/crab/ready_to_evolve.jpg',
  'static/crab/evolving': 'private/chatbot/static/crab/ready_to_evolve.jpg',
  'static/crab/hungry': 'private/chatbot/static/crab/hungry.jpg',
  'static/crab/lonely': 'private/chatbot/static/crab/lonely.jpg',
  'static/crab/very_lonely': 'private/chatbot/static/crab/very_lonely.jpg',
  'static/crab/pee': 'private/chatbot/static/crab/urge_to_urinate.jpg',
  'static/crab/very_pee':
    'private/chatbot/static/crab/strong_urge_to_urinate.jpg',
  'static/crab/scared': 'private/chatbot/static/crab/scared.jpg',
  'static/crab/sick': 'private/chatbot/static/crab/sick.jpg',
  'static/crab/tooth_decay': 'private/chatbot/static/crab/tooth_decay.jpg',
  'static/crab/very_dirty': 'private/chatbot/static/crab/very_dirty.jpg',
  'static/crab/very_hungry': 'private/chatbot/static/crab/very_hungry.jpg',
  'static/crab/fullenergy': 'private/chatbot/static/crab/fullenergy.jpg',

  // Dog
  'static/dog/dead': 'private/chatbot/static/dog/scared.jpg', // missing dead
  'static/dog/dirty': 'private/chatbot/static/dog/dirty.jpg',
  'static/dog/dying': 'private/chatbot/static/dog/scared.jpg', // missing dying
  'static/dog/evolve': 'private/chatbot/static/dog/ready_to_evolve.jpg',
  'static/dog/evolving': 'private/chatbot/static/dog/ready_to_evolve.jpg',
  'static/dog/hungry': 'private/chatbot/static/dog/hungry.jpg',
  'static/dog/lonely': 'private/chatbot/static/dog/lonely.jpg',
  'static/dog/very_lonely': 'private/chatbot/static/dog/very_lonely.jpg',
  'static/dog/pee': 'private/chatbot/static/dog/urge_to_urinate.jpg',
  'static/dog/very_pee':
    'private/chatbot/static/dog/strong_urge_to_urinate.jpg',
  'static/dog/scared': 'private/chatbot/static/dog/scared.jpg',
  'static/dog/sick': 'private/chatbot/static/dog/sick.jpg',
  'static/dog/tooth_decay': 'private/chatbot/static/dog/tooth_decay.jpg',
  'static/dog/very_dirty': 'private/chatbot/static/dog/very_dirty.jpg',
  'static/dog/very_hungry': 'private/chatbot/static/dog/very_hungry.jpg',
  'static/dog/fullenergy': 'private/chatbot/static/dog/fullenergy.jpg',

  // Giraffe
  'static/giraffe/dead': 'private/chatbot/static/giraffe/scared.jpg', // missing dead
  'static/giraffe/dirty': 'private/chatbot/static/giraffe/dirty.jpg',
  'static/giraffe/dying': 'private/chatbot/static/giraffe/scared.jpg', // missing dying
  'static/giraffe/evolve': 'private/chatbot/static/giraffe/ready_to_evolve.jpg',
  'static/giraffe/evolving':
    'private/chatbot/static/giraffe/ready_to_evolve.jpg',
  'static/giraffe/hungry': 'private/chatbot/static/giraffe/hungry.jpg',
  'static/giraffe/lonely': 'private/chatbot/static/giraffe/lonely.jpg',
  'static/giraffe/very_lonely':
    'private/chatbot/static/giraffe/very_lonely.jpg',
  'static/giraffe/pee': 'private/chatbot/static/giraffe/urge_to_urinate.jpg',
  'static/giraffe/very_pee':
    'private/chatbot/static/giraffe/strong_urge_to_urinate.jpg',
  'static/giraffe/scared': 'private/chatbot/static/giraffe/scared.jpg',
  'static/giraffe/sick': 'private/chatbot/static/giraffe/sick.jpg',
  'static/giraffe/tooth_decay':
    'private/chatbot/static/giraffe/tooth_decay.jpg',
  'static/giraffe/very_dirty': 'private/chatbot/static/giraffe/very_dirty.jpg',
  'static/giraffe/very_hungry':
    'private/chatbot/static/giraffe/very_hungry.jpg',
  'static/giraffe/fullenergy': 'private/chatbot/static/giraffe/fullenergy.jpg',

  // Hamster
  'static/hamster/dead': 'private/chatbot/static/hamster/scared.jpg', // missing dead
  'static/hamster/dirty': 'private/chatbot/static/hamster/dirty.jpg',
  'static/hamster/dying': 'private/chatbot/static/hamster/scared.jpg', // missing dying
  'static/hamster/evolve': 'private/chatbot/static/hamster/ready_to_evolve.jpg',
  'static/hamster/evolving':
    'private/chatbot/static/hamster/ready_to_evolve.jpg',
  'static/hamster/hungry': 'private/chatbot/static/hamster/hungry.jpg',
  'static/hamster/lonely': 'private/chatbot/static/hamster/lonely.jpg',
  'static/hamster/very_lonely':
    'private/chatbot/static/hamster/very_lonely.jpg',
  'static/hamster/pee': 'private/chatbot/static/hamster/urge_to_urinate.jpg',
  'static/hamster/very_pee':
    'private/chatbot/static/hamster/strong_urge_to_urinate.jpg',
  'static/hamster/scared': 'private/chatbot/static/hamster/scared.jpg',
  'static/hamster/sick': 'private/chatbot/static/hamster/sick.jpg',
  'static/hamster/tooth_decay':
    'private/chatbot/static/hamster/tooth_decay.jpg',
  'static/hamster/very_dirty': 'private/chatbot/static/hamster/very_dirty.jpg',
  'static/hamster/very_hungry':
    'private/chatbot/static/hamster/very_hungry.jpg',
  'static/hamster/fullenergy': 'private/chatbot/static/hamster/fullenergy.jpg',

  // Sea Otter
  'static/seaotter/dead': 'private/chatbot/static/seaotter/scared.jpg', // missing dead
  'static/seaotter/dirty': 'private/chatbot/static/seaotter/dirty.jpg',
  'static/seaotter/dying': 'private/chatbot/static/seaotter/scared.jpg', // missing dying
  'static/seaotter/evolve':
    'private/chatbot/static/seaotter/ready_to_evolve.jpg',
  'static/seaotter/evolving':
    'private/chatbot/static/seaotter/ready_to_evolve.jpg',
  'static/seaotter/hungry': 'private/chatbot/static/seaotter/hungry.jpg',
  'static/seaotter/lonely': 'private/chatbot/static/seaotter/lonely.jpg',
  'static/seaotter/very_lonely':
    'private/chatbot/static/seaotter/very_lonely.jpg',
  'static/seaotter/pee': 'private/chatbot/static/seaotter/urge_to_urinate.jpg',
  'static/seaotter/very_pee':
    'private/chatbot/static/seaotter/strong_urge_to_urinate.jpg',
  'static/seaotter/scared': 'private/chatbot/static/seaotter/scared.jpg',
  'static/seaotter/sick': 'private/chatbot/static/seaotter/sick.jpg',
  'static/seaotter/tooth_decay':
    'private/chatbot/static/seaotter/tooth_decay.jpg',
  'static/seaotter/very_dirty':
    'private/chatbot/static/seaotter/very_dirty.jpg',
  'static/seaotter/very_hungry':
    'private/chatbot/static/seaotter/very_hungry.jpg',
  'static/seaotter/fullenergy':
    'private/chatbot/static/seaotter/fullenergy.jpg',

  // Star Ball
  'static/starball/dead': 'private/chatbot/static/starball/scared.jpg', // missing dead
  'static/starball/dirty': 'private/chatbot/static/starball/dirty.jpg',
  'static/starball/dying': 'private/chatbot/static/starball/scared.jpg', // missing dying
  'static/starball/evolve':
    'private/chatbot/static/starball/ready_to_evolve.jpg',
  'static/starball/evolving':
    'private/chatbot/static/starball/ready_to_evolve.jpg',
  'static/starball/hungry': 'private/chatbot/static/starball/hungry.jpg',
  'static/starball/lonely': 'private/chatbot/static/starball/lonely.jpg',
  'static/starball/very_lonely':
    'private/chatbot/static/starball/very_lonely.jpg',
  'static/starball/pee': 'private/chatbot/static/starball/urge_to_urinate.jpg',
  'static/starball/very_pee':
    'private/chatbot/static/starball/strong_urge_to_urinate.jpg',
  'static/starball/scared': 'private/chatbot/static/starball/scared.jpg',
  'static/starball/sick': 'private/chatbot/static/starball/sick.jpg',
  'static/starball/tooth_decay':
    'private/chatbot/static/starball/tooth_decay.jpg',
  'static/starball/very_dirty':
    'private/chatbot/static/starball/very_dirty.jpg',
  'static/starball/very_hungry':
    'private/chatbot/static/starball/very_hungry.jpg',
  'static/starball/fullenergy':
    'private/chatbot/static/starball/fullenergy.jpg',

  // Turtle
  'static/turtle/dead': 'private/chatbot/static/turtle/scared.jpg', // missing dead
  'static/turtle/dirty': 'private/chatbot/static/turtle/dirty.jpg',
  'static/turtle/dying': 'private/chatbot/static/turtle/scared.jpg', // missing dying
  'static/turtle/evolve': 'private/chatbot/static/turtle/ready_to_evolve.jpg',
  'static/turtle/evolving': 'private/chatbot/static/turtle/ready_to_evolve.jpg',
  'static/turtle/hungry': 'private/chatbot/static/turtle/hungry.jpg',
  'static/turtle/lonely': 'private/chatbot/static/turtle/lonely.jpg',
  'static/turtle/very_lonely': 'private/chatbot/static/turtle/very_lonely.jpg',
  'static/turtle/pee': 'private/chatbot/static/turtle/urge_to_urinate.jpg',
  'static/turtle/very_pee':
    'private/chatbot/static/turtle/strong_urge_to_urinate.jpg',
  'static/turtle/scared': 'private/chatbot/static/turtle/scared.jpg',
  'static/turtle/sick': 'private/chatbot/static/turtle/sick.jpg',
  'static/turtle/tooth_decay': 'private/chatbot/static/turtle/tooth_decay.jpg',
  'static/turtle/very_dirty': 'private/chatbot/static/turtle/very_dirty.jpg',
  'static/turtle/very_hungry': 'private/chatbot/static/turtle/very_hungry.jpg',
  'static/turtle/fullenergy': 'private/chatbot/static/turtle/fullenergy.jpg',

  // Whale
  'static/whale/dead': 'private/chatbot/static/whale/scared.jpg', // missing dead
  'static/whale/dirty': 'private/chatbot/static/whale/dirty.jpg',
  'static/whale/dying': 'private/chatbot/static/whale/scared.jpg', // missing dying
  'static/whale/evolve': 'private/chatbot/static/whale/ready_to_evolve.jpg',
  'static/whale/evolving': 'private/chatbot/static/whale/ready_to_evolve.jpg',
  'static/whale/hungry': 'private/chatbot/static/whale/hungry.jpg',
  'static/whale/lonely': 'private/chatbot/static/whale/lonely.jpg',
  'static/whale/very_lonely': 'private/chatbot/static/whale/very_lonely.jpg',
  'static/whale/pee': 'private/chatbot/static/whale/urge_to_urinate.jpg',
  'static/whale/very_pee':
    'private/chatbot/static/whale/strong_urge_to_urinate.jpg',
  'static/whale/scared': 'private/chatbot/static/whale/scared.jpg',
  'static/whale/sick': 'private/chatbot/static/whale/sick.jpg',
  'static/whale/tooth_decay': 'private/chatbot/static/whale/tooth_decay.jpg',
  'static/whale/very_dirty': 'private/chatbot/static/whale/very_dirty.jpg',
  'static/whale/very_hungry': 'private/chatbot/static/whale/very_hungry.jpg',
  'static/whale/fullenergy': 'private/chatbot/static/whale/fullenergy.jpg',

  // ===== CONVERSATIONAL CHATBOT =============================================

  // Ball
  'static/conversational/ball/v01/feed':
    'private/chatbot/static/conversational/ball/v01/hungry01_feed.png',
  'static/conversational/ball/v01/yes':
    'private/chatbot/static/conversational/ball/v01/hungry02_yes.png',
  'static/conversational/ball/v01/no':
    'private/chatbot/static/conversational/ball/v01/hungry03_no.png',
  'static/conversational/ball/v01/thanks':
    'private/chatbot/static/conversational/ball/v01/hungry04_thanks.png',
  'static/conversational/ball/v01/coins':
    'private/chatbot/static/conversational/ball/v01/hungry05_coins.png',
  'static/conversational/ball/v01/generic':
    'private/chatbot/static/conversational/ball/v01/hungry06_generic.png',

  // Cat
  'static/conversational/cat/v01/feed':
    'private/chatbot/static/conversational/cat/v01/hungry01_feed.png',
  'static/conversational/cat/v01/yes':
    'private/chatbot/static/conversational/cat/v01/hungry02_yes.png',
  'static/conversational/cat/v01/no':
    'private/chatbot/static/conversational/cat/v01/hungry03_no.png',
  'static/conversational/cat/v01/thanks':
    'private/chatbot/static/conversational/cat/v01/hungry04_thanks.png',
  'static/conversational/cat/v01/coins':
    'private/chatbot/static/conversational/cat/v01/hungry05_coins.png',
  'static/conversational/cat/v01/generic':
    'private/chatbot/static/conversational/cat/v01/hungry06_generic.png',

  // Crab
  'static/conversational/crab/v01/feed':
    'private/chatbot/static/conversational/crab/v01/hungry01_feed.png',
  'static/conversational/crab/v01/yes':
    'private/chatbot/static/conversational/crab/v01/hungry02_yes.png',
  'static/conversational/crab/v01/no':
    'private/chatbot/static/conversational/crab/v01/hungry03_no.png',
  'static/conversational/crab/v01/thanks':
    'private/chatbot/static/conversational/crab/v01/hungry04_thanks.png',
  'static/conversational/crab/v01/coins':
    'private/chatbot/static/conversational/crab/v01/hungry05_coins.png',
  'static/conversational/crab/v01/generic':
    'private/chatbot/static/conversational/crab/v01/hungry06_generic.png',

  // Dog
  'static/conversational/dog/v01/feed':
    'private/chatbot/static/conversational/dog/v01/hungry01_feed.png',
  'static/conversational/dog/v01/yes':
    'private/chatbot/static/conversational/dog/v01/hungry02_yes.png',
  'static/conversational/dog/v01/no':
    'private/chatbot/static/conversational/dog/v01/hungry03_no.png',
  'static/conversational/dog/v01/thanks':
    'private/chatbot/static/conversational/dog/v01/hungry04_thanks.png',
  'static/conversational/dog/v01/coins':
    'private/chatbot/static/conversational/dog/v01/hungry05_coins.png',
  'static/conversational/dog/v01/generic':
    'private/chatbot/static/conversational/dog/v01/hungry06_generic.png',

  // Hamster
  'static/conversational/hamster/v01/feed':
    'private/chatbot/static/conversational/hamster/v01/hungry01_feed.png',
  'static/conversational/hamster/v01/yes':
    'private/chatbot/static/conversational/hamster/v01/hungry02_yes.png',
  'static/conversational/hamster/v01/no':
    'private/chatbot/static/conversational/hamster/v01/hungry03_no.png',
  'static/conversational/hamster/v01/thanks':
    'private/chatbot/static/conversational/hamster/v01/hungry04_thanks.png',
  'static/conversational/hamster/v01/coins':
    'private/chatbot/static/conversational/hamster/v01/hungry05_coins.png',
  'static/conversational/hamster/v01/generic':
    'private/chatbot/static/conversational/hamster/v01/hungry06_generic.png',

  // Giraffe
  'static/conversational/giraffe/v01/feed':
    'private/chatbot/static/conversational/giraffe/v01/hungry01_feed.png',
  'static/conversational/giraffe/v01/yes':
    'private/chatbot/static/conversational/giraffe/v01/hungry02_yes.png',
  'static/conversational/giraffe/v01/no':
    'private/chatbot/static/conversational/giraffe/v01/hungry03_no.png',
  'static/conversational/giraffe/v01/thanks':
    'private/chatbot/static/conversational/giraffe/v01/hungry04_thanks.png',
  'static/conversational/giraffe/v01/coins':
    'private/chatbot/static/conversational/giraffe/v01/hungry05_coins.png',
  'static/conversational/giraffe/v01/generic':
    'private/chatbot/static/conversational/giraffe/v01/hungry06_generic.png',

  // Sea Otter
  'static/conversational/seaotter/v01/feed':
    'private/chatbot/static/conversational/seaotter/v01/hungry01_feed.png',
  'static/conversational/seaotter/v01/yes':
    'private/chatbot/static/conversational/seaotter/v01/hungry02_yes.png',
  'static/conversational/seaotter/v01/no':
    'private/chatbot/static/conversational/seaotter/v01/hungry03_no.png',
  'static/conversational/seaotter/v01/thanks':
    'private/chatbot/static/conversational/seaotter/v01/hungry04_thanks.png',
  'static/conversational/seaotter/v01/coins':
    'private/chatbot/static/conversational/seaotter/v01/hungry05_coins.png',
  'static/conversational/seaotter/v01/generic':
    'private/chatbot/static/conversational/seaotter/v01/hungry06_generic.png',

  // Starball
  'static/conversational/starball/v01/feed':
    'private/chatbot/static/conversational/starball/v01/hungry01_feed.png',
  'static/conversational/starball/v01/yes':
    'private/chatbot/static/conversational/starball/v01/hungry02_yes.png',
  'static/conversational/starball/v01/no':
    'private/chatbot/static/conversational/starball/v01/hungry03_no.png',
  'static/conversational/starball/v01/thanks':
    'private/chatbot/static/conversational/starball/v01/hungry04_thanks.png',
  'static/conversational/starball/v01/coins':
    'private/chatbot/static/conversational/starball/v01/hungry05_coins.png',
  'static/conversational/starball/v01/generic':
    'private/chatbot/static/conversational/starball/v01/hungry06_generic.png',

  // Turtle
  'static/conversational/turtle/v01/feed':
    'private/chatbot/static/conversational/turtle/v01/hungry01_feed.png',
  'static/conversational/turtle/v01/yes':
    'private/chatbot/static/conversational/turtle/v01/hungry02_yes.png',
  'static/conversational/turtle/v01/no':
    'private/chatbot/static/conversational/turtle/v01/hungry03_no.png',
  'static/conversational/turtle/v01/thanks':
    'private/chatbot/static/conversational/turtle/v01/hungry04_thanks.png',
  'static/conversational/turtle/v01/coins':
    'private/chatbot/static/conversational/turtle/v01/hungry05_coins.png',
  'static/conversational/turtle/v01/generic':
    'private/chatbot/static/conversational/turtle/v01/hungry06_generic.png',

  // Whale
  'static/conversational/whale/v01/feed':
    'private/chatbot/static/conversational/whale/v01/hungry01_feed.png',
  'static/conversational/whale/v01/yes':
    'private/chatbot/static/conversational/whale/v01/hungry02_yes.png',
  'static/conversational/whale/v01/no':
    'private/chatbot/static/conversational/whale/v01/hungry03_no.png',
  'static/conversational/whale/v01/thanks':
    'private/chatbot/static/conversational/whale/v01/hungry04_thanks.png',
  'static/conversational/whale/v01/coins':
    'private/chatbot/static/conversational/whale/v01/hungry05_coins.png',
  'static/conversational/whale/v01/generic':
    'private/chatbot/static/conversational/whale/v01/hungry06_generic.png',
};
